<template>
  <ReferenceComponentParentList
    :searchList="list"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    @onClick="onFileSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="medium"
        color="monochrome-06"
      >
        Files
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <FileItem
        :key="option.id"
        :file="option"
        :preventShow="true"
        fileMarkup="element"
        :removeButton="false"
      />
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Action } from "s-vuex-class"

import FileItem from "@/components/File/FileItem.vue"
import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import {
  AttachmentFileMetadataParams,
  FileMetaData,
  FilterSearch,
  ServerResponse,
  TypeConfig
} from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions } from "@/store"
import { parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList,
  FileItem
}

@Options({
  name: "FileList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Prop({ default: null }) readonly referenceFileTargetConfig: TypeConfig | null

  @Action(Actions.ATTACHMENT_FILE_METADATA) getItemFiles: (
    params: AttachmentFileMetadataParams
  ) => Promise<ServerResponse<FileMetaData>>

  componentType = ReferenceType.FILE_LINK
  waitTitle = "reference.search.file"
  result: FileMetaData[] = []
  isLast = true
  filter = FilterSearch.createDefault()

  get list() {
    return this.result?.length > 0 ? this.result : []
  }

  created() {
    this.componentType = (this.$attrs.componentType as ReferenceType) || ReferenceType.FILE_LINK
    this.filter.addSort("createdDate", false)
    this.searchAction = this.onSearchFiles
  }

  queryUpdated(q: string) {
    this.filter.page = 1
    this.filter.q = q.substring(1) ?? ""
    this.search()
  }

  async onSearchFiles() {
    if (!this.referenceFileTargetConfig) return

    const serverResponse = await this.getItemFiles({
      targetId: this.referenceFileTargetConfig.targetId,
      filter: this.filter,
      projectId: this.project?.id,
      resourceType: this.referenceFileTargetConfig.type
    })
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }

  onEnterHandler() {
    this.onFileSelected(this.result[this.selectedIndex])
  }

  onFileSelected(payload) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }
}
</script>
